// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__1YeE5","question":"Question_question__2NjSw","description":"Question_description__JABhc"};